import type { SupportedCurrencies } from 'types/currencies'

export const getProviderColor = (activeCurrency: SupportedCurrencies, isLoggedIn: boolean) => {
  if (activeCurrency === 'SC' && isLoggedIn) {
    return 'green'
  }

  if (activeCurrency === 'GC' && isLoggedIn) {
    return 'orange'
  }

  return 'pink'
}
